// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
require('!style-loader!css-loader!sass-loader!./assets/css/common.scss');

import JsEncrypt from 'jsencrypt/bin/jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt

import bus from '../src/assets/js/bus'


Vue.config.productionTip = false

function getCaption(obj){
  var index= obj.lastIndexOf("\/")
  obj=obj.substring(index+1,obj.length);
//  console.log(obj);
  return obj;
}

//路由的前置处理
router.beforeEach((to, from, next) => {
  window.prerenderReady = false;
  let firstLetter = getCaption(to.path)
  let [startIndex, endIndex, subLength] = [0,1,2]
  if(to.matched.length == 0){
    next('/')
    return
  }
  if((navigator.userAgent.match(/(phone|pad|pod|Iphone|iPad|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
    console.log('移动端')
    if(to.path == '/'){
      next("/mIndex");
    } else if(!to.path.startsWith('/m')){
      next('m' + firstLetter.substring(startIndex,endIndex).toUpperCase() + to.path.substr(endIndex+1,to.path.length - subLength))
    } else {
      next()
    }
  } else {
    console.log('PC端')
    var userInfo = localStorage.userInfo;
    var pathArr = ['/login','/','/index','/about','/fund','/healthy-fund','/news','/job','/news-info'];
    var ifTruePath = true;
    for (var data of pathArr){
      if(to.path == data){
        ifTruePath = false;
        break;
      }
    }
    if(ifTruePath && !to.path.startsWith('/m')){
      if(userInfo != undefined && userInfo != null){
        if(to.path == '/'){
          next("/index");
        } else {
          next();
        }
      } else {
        next('/login');
      }
    } else {
      if(to.path == '/'){
        next("/index");
      } else if(firstLetter.substring(0,1) === 'm'){
        next(firstLetter.substring(1,2).toLowerCase() + to.path.substr(3,to.path.length - 2))
      } else {
        next();
      }
    }
  }

})

router.afterEach((to, from) => {
  window.prerenderReady = true
  //防止页面跳转后保留在之前页面滚动到的位置
  window.scrollTo(0, 0);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js